// File: frontend/src/main.tsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/global.css' // Tailwind CSS

// PWA Service Worker Registration
// REMOVED: Manual Service Worker registration.
// vite-plugin-pwa injects a script (registerSW.js) into index.html to handle this.
// This script will correctly use the `base` path and SW scope.

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)